import React from 'react'
// import Cards from '../Cards'
import { Box, Heading, Image, Stack, Text } from '@chakra-ui/react'
import { Card, CardBody, CardFooter} from '@chakra-ui/react';
import { FaGithub} from "react-icons/fa";
import {BiLinkAlt} from "react-icons/bi"
import {BsArrowDown} from 'react-icons/bs';
import {GrSettingsOption} from "react-icons/gr";
import preshop from "../../assets/preshop.png";
import cryptof from "../../assets/cryptof.png";
import drive from "../../assets/drive.png";
import coursify from "../../assets/coursify.png";
const Projects = () => {
  return (
    <div>
      <Box padding={"8"} justifyContent={"flex"} display={'flex'}  paddingLeft={"10"}>
        <GrSettingsOption size={30} style={{marginRight:"8", marginTop:"2", marginLeft:"4" }}/>
        <Text  fontWeight={'bold'} fontSize={'2xl'} textTransform={'uppercase'} letterSpacing={2}>My Side Hustles</Text>
        <BsArrowDown  size={35} style={{paddingTop:"3"}}/>
      </Box>

      <Box>
      <Box paddingLeft={["5","10"]} paddingRight={["5","20"]} paddingBottom={5} >
    <Card direction={{ base: 'column', sm: 'row' }}
    overflow='hidden'
    variant='outline'
    padding={5}
    >
  <Image
    objectFit='cover'
    maxW={{ base: '100%', sm: '500px' }}
    src={coursify}
    alt='coursify-icon'
  />

  <Stack padding={5}>
    <CardBody>
      <Heading size='md'>Coursify</Heading>

      <Text py='2'>
      Revolutionize learning with our cutting-edge online coursify platform. Powered by the MERN stack, we offer interactive courses, seamless user experience, and robust features for an unparalleled educational journey. Enroll now!
      </Text>
    </CardBody>

    <CardFooter justifyContent={"space-between"}>
      <a href='https://github.com/avibhawnani/coursify-frontend'><FaGithub size={24}></FaGithub></a>
      {/* <a href="/"><BiLinkAlt size={24}></BiLinkAlt></a> */}
      <Text alignContent={["right",""]} textAlign={"right"} textTransform={'uppercase'}>Jun 2023 - Jul 2023</Text>
    </CardFooter>
  </Stack>
</Card>
</Box>






    <Box paddingLeft={["5","10"]} paddingRight={["5","20"]} paddingBottom={5} >
    <Card direction={{ base: 'column', sm: 'row' }}
    overflow='hidden'
    variant='outline'
    padding={5}
    >
  <Image
    objectFit='cover'
    maxW={{ base: '100%', sm: '500px' }}
    src={preshop}
    alt='med3-icon'
  />

  <Stack padding={5}>
    <CardBody>
      <Heading size='md'>PreShop</Heading>

      <Text py='2'>
      Experience the future of online shopping with our innovative preshop eCommerce platform. Built on React.js, powered by Stripe and Strapi, we offer secure transactions, customizable designs, and effortless product management. Start selling today!
      </Text>
    </CardBody>

    <CardFooter justifyContent={"space-between"}>
      <a href='https://github.com/avibhawnani/PreShop-Ecommerce-App'><FaGithub size={24}></FaGithub></a>
      {/* <a href="/"><BiLinkAlt size={24}></BiLinkAlt></a> */}
      <Text alignContent={["right",""]} textAlign={"right"} textTransform={'uppercase'}>Apr 2023 - May 2023</Text>
    </CardFooter>
  </Stack>
</Card>
</Box>



<Box paddingLeft={["5","10"]} paddingRight={["5","20"]} paddingBottom={5} >
    <Card direction={{ base: 'column', sm: 'row' }}
    overflow='hidden'
    variant='outline'
    padding={5}
    >
  <Image
    objectFit='cover'
    maxW={{ base: '100%', sm: '500px' }}
    src={cryptof}
    alt='med3-icon'
  />

  <Stack padding={5}>
    <CardBody>
      <Heading size='md'>CryptoFund</Heading>

      <Text py='2'>
      CryptoFund is an innovative crowdfunding platform that harnesses the power of blockchain technology to revolutionize the way projects are funded. Our platform provides a transparent, secure, and decentralized ecosystem, empowering innovators and entrepreneurs to raise capital and turn their ideas into reality.
      </Text>
    </CardBody>

    <CardFooter justifyContent={"space-between"}>
      <a href='https://github.com/avibhawnani/CrowdFunding'><FaGithub size={24}></FaGithub></a>
      {/* <a href="https://med-three.netlify.app/"><BiLinkAlt size={24}></BiLinkAlt></a> */}
      <Text alignContent={["right",""]} textAlign={"right"} textTransform={'uppercase'}>Apr 2023 - May 2023</Text>
    </CardFooter>
  </Stack>
</Card>
</Box>




<Box paddingLeft={["5","10"]} paddingRight={["5","20"]} paddingBottom={5} >
    <Card direction={{ base: 'column', sm: 'row' }}
    overflow='hidden'
    variant='outline'
    padding={5}
    >
  <Image
    objectFit='cover'
    maxW={{ base: '100%', sm: '500px' }}
    src={drive}
    alt='med3-icon'
  />

  <Stack padding={5}>
    <CardBody>
      <Heading size='md'>Drive 3.0</Heading>

      <Text py='2'>
      Unlock the potential of decentralized storage with our groundbreaking Web3-based Google Drive alternative. Built with React.js and blockchain technology, enjoy secure, immutable file storage and seamless collaboration. Discover the future of data management today!
      </Text>
    </CardBody>

    <CardFooter justifyContent={"space-between"}>
      <a href='https://github.com/avibhawnani/Drive3'><FaGithub size={24}></FaGithub></a>
      <a href="https://drivethree.netlify.app/"><BiLinkAlt size={24}></BiLinkAlt></a>
      <Text alignContent={["right",""]} textAlign={"right"} textTransform={'uppercase'}>Jan 2023 - Feb 2023</Text>
    </CardFooter>
  </Stack>
</Card>
</Box>

      </Box>
    
    </div>
  )
}

export default Projects